import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "colour",
  "use": "colour-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"colour\">\n<path d=\"M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z\" fill=\"black\" />\n<path d=\"M7 11.6251V17H13.1513V14.001H16.2248V10.9647H18L16.2248 5.03738V5H10.7163V7.38006H13.7899V11.6251H7Z\" fill=\"white\" />\n<path d=\"M4 5V8.00208H6.99862V11H13V8.00208H10.0014V5H4Z\" fill=\"#FBCA00\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol